import TitlePage from "@components/atoms/TitlePage/TitlePage";
import DynamicTable from "../DynamicTable/DynamicTable";
import { IRemisionStateHistoryUI } from "src/types/organisms";
const RemisionStateHistoryUI = ({
  title,
  subtitle,
  headers,
  rows,
  pages,
  isLoading,
  onChangePage,
  emptyMessage
}: IRemisionStateHistoryUI) => {
  return <>
      <TitlePage title="Historial de estados" subtitle={subtitle} />
      <DynamicTable title={title} headers={headers} rows={rows} pages={pages} isLoading={isLoading} onChangePage={onChangePage} emptyMessage={emptyMessage} />
    </>;
};
export default RemisionStateHistoryUI;